<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Payment ID" v-model="formData.id">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                     
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_OVERVIEW }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Overview</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_ITEMS }"><a @click="onClickTabItems()" href="#tab_2" data-toggle="tab" aria-expanded="true">Items</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_ITEMS }"><a @click="onClickTabNotification()" href="#tab_3" data-toggle="tab" aria-expanded="true">Notification</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_OVERVIEW }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputEmail" class="col-sm-4 control-label">Email</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputEmail" placeholder="" v-model="formData.email">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTotalAmount" class="col-sm-4 control-label">Total Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputTotalAmount" placeholder="" v-model="formData.total_amount" ref="totalAmount">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputFirstName" class="col-sm-4 control-label">First Name</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputFirstName" placeholder="" v-model="formData.first_name" ref="firstName">
                              </div>
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCurrency" class="col-sm-4 control-label">Currency</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputCurrency" placeholder="" v-model="formData.currency_name">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputLastName" class="col-sm-4 control-label">Last Name</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputLastName" placeholder="" v-model="formData.last_name" ref="lastName">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProject" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProject" placeholder="" v-model="formData.project_name">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPhone" class="col-sm-4 control-label">Phone</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPhone" placeholder="" v-model="formData.phone" ref="phone">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProcessDate" class="col-sm-4 control-label">Process Date</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProcessDate" placeholder="" v-model="formData.process_date">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputDescription" class="col-sm-4 control-label">Description</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputDescription" placeholder="" v-model="formData.description">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputBookingDate" class="col-sm-4 control-label">Booking Date</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputBookingDate" placeholder="" v-model="formData.booking_date">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTransactionID" class="col-sm-4 control-label">Transaction ID</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputTransactionID" placeholder="" v-model="formData.transaction_id">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPaymentType" class="col-sm-4 control-label">Payment Type</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPaymentType" placeholder="" v-model="formData.payment_type">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPaymentMethod" class="col-sm-4 control-label">Payment Method</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPaymentMethod" placeholder="" v-model="formData.payment_method">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputOrderName" class="col-sm-4 control-label">Order</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputOrderName" placeholder="" v-model="formData.order_name">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputBank" class="col-sm-4 control-label">Bank</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputBank" placeholder="" v-model="formData.bank">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCardType" class="col-sm-4 control-label">Card Type</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputCardType" placeholder="" v-model="formData.card_type">
                              </div>                     
                            </div>
                          </div>
                        </div>                        
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_ITEMS }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="text-align:left;">ID</th>
                                <th style="text-align:left;">Name</th>
                                <th style="text-align:right;">Quantity</th>
                                <th style="text-align:right;">Price</th>
                                <th style="text-align:right;">Amount</th>
                                <th style="text-align:center;">Currency</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listItem" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceItem + i + 1}}</td>
                                <td style="text-align:left;" nowrap>{{ row.item_id }}</td>
                                <td style="text-align:left;">{{ row.name }}</td>
                                <td style="text-align:right;">{{ row.quantity }}</td>
                                <td style="text-align:right;">{{ row.price }}</td>
                                <td style="text-align:right;">{{ row.amount }}</td>
                                <td style="text-align:center;">{{ row.currency_name }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.order_id }}</td>
                                <td hidden>{{ row.currency_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                        </div>                        
                      </div>
                    </div>                    
                    <div v-bind:class="{ active: tabActive == TAB_NOTIFICATION }" class="tab-pane" id="tab_3">
                      <div class="box no-border">
                        <div class="box-header">
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="text-align:center;">Process Date</th>
                                <th style="text-align:left;">Transaction ID</th>
                                <th style="text-align:center;">Status Code</th>
                                <th style="text-align:left;">Status Message</th>
                                <th style="text-align:left;">Signature Key</th>
                                <th style="text-align:center;">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listNotification" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceNotification + i + 1}}</td>
                                <td style="text-align:center;">{{ row.process_date }}</td>
                                <td style="text-align:left;">{{ row.transaction_id }}</td>
                                <td style="text-align:right;">{{ row.status_code }}</td>
                                <td style="text-align:right;">{{ row.status_message }}</td>
                                <td style="text-align:right;">{{ row.signature_key }}</td>
                                <td style="text-align:center;">{{ row.status }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.payment_id }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                        </div>                        
                      </div>
                    </div> 
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" v-model="formData.id">
              <input type="hidden" class="form-control" v-model="formData.projectId">
              <input type="hidden" class="form-control" v-model="formData.company_id">
              <input type="hidden" class="form-control" v-model="formData.currency_id">
              <input type="hidden" class="form-control" v-model="formData.order_id">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_OVERVIEW = 'tabOverview'
const TAB_ITEMS = 'tabItems'
const TAB_NOTIFICATION = 'tabNotification'

export default {
  name: 'PaymentOrderForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_OVERVIEW: TAB_OVERVIEW,
      TAB_ITEMS: TAB_ITEMS,
      TAB_NOTIFICATION: TAB_NOTIFICATION,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        description: '',
        total_amount: 0,
        currency_id: 0,
        company_id: 0,
        company_name: '',
        project_id: 0,
        project_name: '',
        process_date: '',
        booking_date: '',
        status: '',
        payment_type: '',
        order_id: 0,
        order_name: '',
        clearing: false,
        bank: '',
        card_type: ''
      },
      listItem: null,
      startSequenceItem: 0,
      listNotification: null,
      startSequenceNotification: 0,
      tabActive: '',
      originalcallback: '',
      prevRoute: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_OVERVIEW
    this.clearing = this.$route.params.clearingStatus
    this.getDetail(this.clearing)
  },
  mounted() {
  },
  methods: {
    getDetail(clearingStatus) {
      api
        .request('Payment', 'get', '/api/Payment/' + this.formData.id + '?clearing_status=' + clearingStatus, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.callback
      }
      this.$router.push({ name: this.callback, params: params })
    },
    onClickTabItems() {
      this.inquiryItem()
    },
    inquiryItem() {
      api
        .request('Payment', 'get', '/api/Payment/' + this.formData.id + '/GetItems?clearing_status=' + this.clearing, null)
        .then(response => {
          var data = response.data
          this.listItem = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabNotification() {
      this.inquiryNotification()
    },
    inquiryNotification() {
      api
        .request('Payment', 'get', '/api/Payment/' + this.formData.id + '/GetNotification', null)
        .then(response => {
          var data = response.data
          this.listNotification = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PaymentForm.vue?5aab39d2